(function($){
        
	// Add Loaded Class
	$('.ptx-oversizedfooter').addClass('ptx-oversizedfooter--loaded');
  
})(jQuery);